import styled from 'styled-components';

export const SVGBackground = styled.div<{ $src: string }>`
  position: absolute;
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
  background-image: url(${({ $src }) => $src});
  background-size: cover;
  background-position: center top;
`;

export const UnBrandedBackground = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
`;

export const Wrapper = styled.div`
  display: grid;
  height: 100vh;
  min-height: 750px;
  grid-template-rows: minmax(30%, auto) auto 1fr auto;
`;

export const Separator = styled.div`
  flex: 1 1 auto;
`;
